import { Link } from 'react-router-dom'
import { formatDate } from '../features/plans/api'
import { useMyWork } from '../features/plans/itemApi'

export function MyWorkPage() {
  const { data: work, isPending, isError } = useMyWork()

  if (isPending) return <p>Loading your work…</p>
  if (isError) {
    return (
      <p role="alert" className="error">
        Could not load your assigned work.
      </p>
    )
  }

  return (
    <section>
      <h1>My work</h1>
      <p className="muted">
        Everything still open and assigned to you, across every event being run. Soonest first.
      </p>

      {work.length === 0 ? (
        <p className="empty">Nothing assigned to you right now.</p>
      ) : (
        <ul className="card-list">
          {work.map((item) => (
            <li key={item.id} className="card">
              <Link className="card-title" to={`/events/${item.eventId}`}>
                {item.title}
              </Link>
              <div className="card-meta">
                <span>
                  {item.eventName} <span className="code">{item.eventCode}</span>
                </span>
                <span>{item.phaseDisplayName}</span>
                {item.sectionTitle ? <span>{item.sectionTitle}</span> : null}
                <span>{item.dueDate ? `Due ${formatDate(item.dueDate)}` : 'No due date'}</span>
              </div>
              <div className="card-tags">
                <span className="badge">
                  {item.kind === 'Milestone' ? 'Milestone' : 'Checklist item'}
                </span>
                {item.urgency === 'Overdue' ? <span className="badge overdue">Overdue</span> : null}
                {item.urgency === 'AtRisk' ? (
                  <span className="badge at-risk-text">Due soon</span>
                ) : null}
              </div>
            </li>
          ))}
        </ul>
      )}
    </section>
  )
}
